// Core
import React, { useEffect, useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

//Assets

// logo
import Logo from 'assets/images/logo.png'


// Styles
import './styles.scss';
import 'react-photo-view/dist/react-photo-view.css';

import { Avatar, Button as ButtonAntD, Drawer, Dropdown, Popover, Radio, Space } from 'antd';
import { CrownOutlined, FacebookOutlined, TranslationOutlined, TeamOutlined, BorderOutlined, HomeOutlined, InstagramOutlined, LogoutOutlined, MailOutlined, MenuOutlined, FormOutlined, QuestionCircleOutlined, SearchOutlined, SettingFilled, TwitterOutlined, UserOutlined, YoutubeOutlined, GiftOutlined } from '@ant-design/icons';
import Login from 'components/modals/Login';
import Unsubscribe from 'components/modals/Unsubscribe';
import Button from '../Button';
import LogOut from 'components/modals/LogOut';
import { fetchData } from 'utils/fetch';
import { restAPIs } from 'utils/restAPIs';
import { APP_ID } from 'config/constants';
import InputField from '../InputField';

const Header = () => {
  const { userDetails, currentLang } = useSelector((store) => store.commonData);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [header, setHeaderClass] = useState("__header");
  const [openLogin, setOpenLogin] = useState(false);
  const [currLng, setCurrLng] = useState('ENG')
  const [show, setShow] = useState(false);
  const [openLogOut, setLogOutOpen] = useState(false);

  const [searchInValue, setSearchInValue] = useState(1);
  const [searchForValue, setSearchForValue] = useState(1);

  const [isLoading] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState('');
  const { searchkey } = data;

  const [openPopOver, setOpenPopOver] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const listenScrollEvent = event => {
    if (window.scrollY < 51) {
      return setHeaderClass("__header");
    } else if (window.scrollY > 50) {
      return setHeaderClass("__header header_black");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);

  const handleCloseLogin = () => {
    setOpenLogin(false)
  }

  const handleChangeLang = async (value) => {
    setCurrLng(value === 'ar' ? 'عربي' : 'ENG')
    i18n.changeLanguage(value);
    dispatch({
      type: 'currentLang',
      value: { lang: value, id: value === 'ar' ? 1 : 2 }
    });
    if (value === 'ar') {
      document.body.classList.add('arabic');
    }
    else {
      document.body.classList.remove('arabic')
    }
    const localDetails = localStorage.getItem('userDetails');
    if (localDetails) {
      const formData = new FormData();
      formData.append('language', value);
      formData.append('appId', APP_ID);
      const res = await fetchData(restAPIs.changeLanguage(formData));
      if (res.statusCode === 200) {
        dispatch({
          type: 'userDetails',
          value: { ...userDetails, language: res.language }
        });
      }
    }
  };


  const checkSubsription = async () => {
    const formD = new FormData();
    formD.append('appId', APP_ID)
    const res = await fetchData(restAPIs.subscriptionForm(formD));
    dispatch({
      type: 'userDetails',
      value: { ...res, language: res.language == "1" ? 'ar' : 'en' }
    });
    localStorage.setItem('userDetails', JSON.stringify(res));
    localStorage.setItem('sessiontoken', res.sessionToken);
    i18n.changeLanguage(res.language == "1" ? 'ar' : 'en');
    dispatch({
      type: 'currentLang',
      value: { lang: res.language ? (res.language == "1" ? 'ar' : 'en') : 'en', id: res?.language ?  +res.language : 2 }
    });

    if (res.language == "1") {
      document.body.classList.add('arabic');
    }
    else {
      document.body.classList.remove('arabic')
    }

  }


  const items = [
    {
      label: <a onClick={() => handleChangeLang('ar')}>عربي</a>,
      key: '0',

    },
    {
      label: <a onClick={() => handleChangeLang('en')}>ENG</a>,
      key: '1',
    },
  ];


  useEffect(() => {
    const localDetails = localStorage.getItem('userDetails');
    if (currentLang.lang === 'ar') {
      document.body.classList.add('arabic');
    }
    else {
      document.body.classList.remove('arabic')
    }

    if (localDetails) {
      checkSubsription();
    }
    else {
      i18n.changeLanguage(currentLang.lang);
    }
  }, []);

  const openUnsubscribe = () => {
    setShow(true);
  };

  const closeUnsubscribe = (value) => {
    setShow(false);
  };

  const gotoHome = () => {
    navigate('home')
  }

  const onChangeSearchFor = (e) => {
    setSearchForValue(e.target.value);
  };
  
  const handleOnChange = (key) => (value) => {
    setError({
      ...error,
      [key]: null
    });
    setData({
      ...data,
      [key]: value
    });
  };

  const onChangeSearchIn = (e) => {
    setSearchInValue(e.target.value);
  };

  const handleSubmit = () => {
    const errors = {
      searchkey: !searchkey && 'Enter your search word',
    };
    setError(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (!isFormValid) return;
    setOpenPopOver(false)
    navigate(`/search?searchText=${searchkey}&searchFor=${searchForValue}&searchIn=${searchInValue}`)
  }

  return (
    <>
      <header>
        <div className={header}>
          <div className='__dr_menu'>
            <ButtonAntD icon={<MenuOutlined />} onClick={showDrawer} />
            <img className='__logo' src={Logo} alt="Hawaya" onClick={() => gotoHome()} />
            <h2 onClick={() => gotoHome()} style={{cursor:'pointer'}}>{t('hawaya')}</h2>
          </div>
          <div className='__menu'>
            <NavLink to={'home'} end>{t('home')}</NavLink>
            <NavLink to={'poems'} end>{t('poems')}</NavLink>
            <NavLink to={'poets'} end>{t('poets')}</NavLink>
            <NavLink to={'letters'} end>{t('letters')}</NavLink>
          </div>
          <div className='__profile_sec'>
            <Popover
            placement="bottomRight"
              open={openPopOver}
              onOpenChange={(visible) => setOpenPopOver(visible)}
              trigger="click"
              content={
                <div className='__search_box'>
                  <div className='__input_sec'>
                    <InputField
                      type="text"
                      placeholder="Search"
                      value={searchkey}
                      onChange={handleOnChange('searchkey')}
                      error={error.searchkey}
                    />
                    <Button
                      icon={<SearchOutlined />}
                      handleOnClick={handleSubmit}
                      loading={isLoading}
                      withLoader
                    />
                  </div>
                  <div className='__filter_sec'>
                    <div className='__single'>
                      <h5>Search In</h5>
                      <Radio.Group onChange={onChangeSearchIn} value={searchInValue}>
                        <Space direction="vertical">
                          <Radio value={1}>Poems</Radio>
                          <Radio value={2}>Poets</Radio>
                        </Space>
                      </Radio.Group>
                    </div>
                    <div className='__single'>
                      <h5>Search For</h5>
                      <Radio.Group onChange={onChangeSearchFor} value={searchForValue}>
                        <Space direction="vertical">
                          <Radio value={2}>Any</Radio>
                          <Radio value={1}>Exact Phrase</Radio>
                        </Space>
                      </Radio.Group>
                    </div>
                  </div>
                </div>
              }
            >
              <span style={{ cursor: 'pointer' }}>
                <SearchOutlined />
              </span>
            </Popover>




            <Dropdown
              menu={{
                items,
                selectable: true,
              }}
              trigger={['click']}
            >
              <a className='__lng' onClick={(e) => e.preventDefault()}>
                {currLng}
              </a>
            </Dropdown>

            {userDetails?.fullname ? <NavLink to={'settings'} end ><Avatar src={<img src={userDetails?.profile_pic} alt={userDetails?.fullname} />} /></NavLink> : <a className='__prof-btn' onClick={() => setOpenLogin(true)}><UserOutlined /></a>}
            <Login open={openLogin} onClose={() => handleCloseLogin()} />
          </div>
        </div>
      </header>

      <Drawer  width={300} closable={false} className='__drawer_menu' placement="left" onClose={onClose} open={open}>
        <div className='__drw_inr'>
          <div>
            <p><NavLink to={'home'} end onClick={onClose}><HomeOutlined />{t('home')}</NavLink></p>
            <p><NavLink to={'poems'} end onClick={onClose}><FormOutlined />{t('poems')}</NavLink></p>
            <p><NavLink to={'poets'} end onClick={onClose}><TeamOutlined />{t('poets')}</NavLink></p>
            <p><NavLink to={'letters'} end onClick={onClose}><TranslationOutlined />{t('letters')}</NavLink></p>
            <div className='__divider'></div>
            <p>{(userDetails?.fullname && userDetails?.subscription != 0) ?
              <Button icon={<CrownOutlined />} className='mb-1' style={{ width: '100%', height: '40px', background: '#d3044a' }} handleOnClick={openUnsubscribe} label={t('unsubscribe')} />
              : <NavLink to={'subscribe'} end style={{ width: '100%' }} onClick={onClose}><Button icon={<CrownOutlined />} className='mb-1' style={{ width: '100%', height: '40px' }} label={t('subscribe')} /></NavLink>
            }</p>
            <div className='__divider'></div>
            <p><NavLink to={'about'} end onClick={onClose}><BorderOutlined />{t('about_us')}</NavLink></p>
            <p><NavLink to={'help-and-support'} end onClick={onClose}><QuestionCircleOutlined />{t('help_support')}</NavLink></p>
            {userDetails&&
            <p><NavLink to={'refer-and-earn'} end onClick={onClose}><GiftOutlined />{t('refer_earn')}</NavLink></p>}
            <p><NavLink to={'contact'} end onClick={onClose}><MailOutlined />{t('contact_us')}</NavLink></p>
            <div className='__divider'></div>
            {userDetails?.fullname ? <p>
              <NavLink to={'settings'} end onClick={onClose}><SettingFilled />{t('settings')}</NavLink>
              <a className='__prof-btn' onClick={() => setLogOutOpen(true)}><LogoutOutlined />{t('sign_out')}</a>
            </p> : <a className='__prof-btn' onClick={() => setOpenLogin(true)}><UserOutlined /> {t('login')}</a>
            }
          </div>

          <div className='__social_icons'>
            <h5>{t('powered_by')}</h5>
            <h2>{t('electronic_village')}</h2>
            <div>
              <a ><FacebookOutlined /></a>
              <a><InstagramOutlined /></a>
              <a><YoutubeOutlined /></a>
              <a><TwitterOutlined /></a>
            </div>
          </div>
        </div>
      </Drawer>

      <LogOut open={openLogOut} onClose={() => setLogOutOpen(false)} />
      <Unsubscribe
        open={show}
        onClose={closeUnsubscribe}
      />
    </>
  );
};

export default Header;
